var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{attrs:{"fluid":""}},[_c('h3',{staticClass:"mb-4"},[_vm._v("پروفایل")]),_c('profile-component',{attrs:{"submit":_vm.updateProfile,"user":_vm.profile,"changeRole":false},on:{"userUpdate":_vm.loadProfile}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }